import { render, staticRenderFns } from "./IssueItem.vue?vue&type=template&id=3e48ceaa&scoped=true"
import script from "./IssueItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./IssueItem.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./IssueItem.vue?vue&type=style&index=0&id=3e48ceaa&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e48ceaa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e48ceaa')) {
      api.createRecord('3e48ceaa', component.options)
    } else {
      api.reload('3e48ceaa', component.options)
    }
    module.hot.accept("./IssueItem.vue?vue&type=template&id=3e48ceaa&scoped=true", function () {
      api.rerender('3e48ceaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/proofreading/revising/IssueItem.vue"
export default component.exports